import { api } from '../helpers/api'
import config from '../config'
import { setUser } from './user'
import { fetchCart } from './cart'
import { fetchPriceOptions } from './price'
import { initializePreorderData } from './preOrder'

import qs from 'query-string'

export const SET_SESSION = 'SET_SESSION'
export const SHOP_RETRIEVED = 'SHOP_RETRIEVED'
export const SHOP_INITIALIZED = 'SHOP_INITIALIZED'

const receiveShop = (shop, headless) => {
  return {
    type: SHOP_RETRIEVED,
    shop,
    headless
  }
}

const setSession = (sessionToken, settings) => {
  return  {
    type: SET_SESSION,
    sessionToken,
    settings,
  }
}

export const init = () => {
  return (dispatch, getState) => {
    // fetch shop
    let fetchShopUrl = config.FETCH_SHOP_URL
    let preferredLocale = null

    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        preferredLocale = window.localStorage.getItem('locale')
      } catch (error) {
        if (process.env.NODE_ENV === 'development')
          console.warn('Unable to read preferred locale', error) // eslint-disable-line no-console
      }
    }

    if (preferredLocale) {
      const separator = fetchShopUrl.indexOf('?') === -1 ? '?' : '&'
      fetchShopUrl = `${fetchShopUrl}${separator}locale=${preferredLocale}`
    }

    return fetch(fetchShopUrl)
      .then(response => {
        return response.json()
      }).then(response => {
        const params = qs.parse(window.location.search)
        const headless = params.headless
        dispatch(receiveShop(response.data, headless))
        const shop = getState().shop
        // fetch session
        api(`${shop.apiUrl}/session`, 'post', {webshopId: shop.webshopId})
        .then(r => r.json())
        .then(r => {
          const sessionToken = localStorage.getItem('sessionToken');
          if (r.data.token !== sessionToken) {
            localStorage.setItem('sessionToken', r.data.token)
            localStorage.removeItem('user')
            dispatch(setUser(null))
            dispatch(setSession(r.data.token, r.data.settings))
          } else {
            dispatch(setUser(JSON.parse(localStorage.getItem('user'))))
            dispatch(setSession(r.data.token, r.data.settings))

            if (getState().user.isLoggedIn)
              dispatch(initializePreorderData())
          }
          dispatch(fetchCart())
          dispatch(fetchPriceOptions())
        })
        .catch(e => {
          console.error(e);
        })
      })
      .catch(err => console.error(err))
  }
}

export const changeLocale = (nextLocale) => {
  return (dispatch, getState) => {
    if (!nextLocale) return Promise.resolve()

    const state = getState()
    const currentLocale = state?.intl?.locale
    if (currentLocale === nextLocale) return Promise.resolve()

    let fetchShopUrl = config.FETCH_SHOP_URL
    const separator = fetchShopUrl.indexOf('?') === -1 ? '?' : '&'
    fetchShopUrl = `${fetchShopUrl}${separator}locale=${nextLocale}`

    return fetch(fetchShopUrl)
      .then(response => response.json())
      .then(response => {
        const headless = state?.shop?.headless
        dispatch(receiveShop(response.data, headless))
        try {
          localStorage.setItem('locale', nextLocale)
        } catch (error) {
          if (process.env.NODE_ENV === 'development')
            console.warn('Unable to persist locale', error) // eslint-disable-line no-console
        }
      })
      .catch(error => {
        console.error(error)
        throw error
      })
  }
}
